<template>
  <div class="opage">
    <div>
      <!--  意见反馈 -->
      <!-- 搜索 -->
      <div class="body">
        <!-- 状态筛选 -->
        <div class="tabs">
          <el-tabs v-model="datas.status" type="card" @tab-click="feedbackList">
            <!-- 全部 -->
            <!-- <el-tab-pane :label="$t('message.all')" name="">
            </el-tab-pane> -->
            <!-- 待确认 -->
            <!--2023/03/2 数字先不放,需要后端给接口 -->
            <el-tab-pane :label="$t('message.toBeConfirmed')" name="1">
            </el-tab-pane>
            <!-- 已确认 -->
            <el-tab-pane :label="$t('message.confirmed')" name="2">
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="search">
          <div class="row">
            <!--文本: 请输入客户ID -->
            <div class="item">
              <el-input v-model="datas.user_id" :placeholder="$t('message.pleaseEnterTheCustomerID')" clearable
                onfocus="this.select()">
              </el-input>
            </div>
            <!--文本: 请输入客户名称 -->
            <div class="item">
              <el-input v-model="datas.realname" :placeholder="$t('message.pleaseEnterTheCustomerName')" clearable
                onfocus="this.select()">
              </el-input>
            </div>
            <!-- 业务 -->
            <div class="item">
              <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
                <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 采购 -->
            <div class="item">
              <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
                <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 配货 -->
            <div class="item">
              <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
                <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!-- 重置 -->
            <!-- <el-button @click="reset">
              {{ $t("message.reset") }}
            </el-button> -->
          </div>
        </div>
        <div class="table">
          <ol>
            <!-- 客户信息 -->
            <li>
              {{ $t("message.userInfo") }}
            </li>
            <!-- 对应人员 -->
            <li>
              {{ $t("message.correspondingPerson") }}
            </li>
            <!-- 页面链接 -->
            <li class="flex2">
              {{ $t("message.pageLink") }}
            </li>
            <!-- 提出时间 -->
            <li>
              {{ $t("message.forwardTime") }}
            </li>
            <!-- 问题描述 -->
            <li class="flex2">
              {{ $t("message.problemDescriptionMS") }}
            </li>
            <!-- 图片 -->
            <li class="imageLI">
              {{ $t("message.picture") }}
            </li>
            <!-- 业务备注 -->
            <li class="flex15">
              {{ $t("message.serviceRemarks") }}
            </li>
            <!-- 运营备注 -->
            <li class="flex15">
              {{ $t("message.userRamrk") }}
            </li>
            <!-- 操作 -->
            <li class="flex05">
              {{ $t("message.operation") }}
            </li>
            <!-- 确认状态（时间） -->
            <li>
              {{ $t("message.confirmTheStatus") }}({{ $t("message.times") }})
            </li>
          </ol>
          <ul v-for="(tableItem, tableIndex) in tableData" :key="tableIndex">
            <!-- 客户信息 -->
            <li>
              <div class="listShow">
                <p>{{ tableItem.user ? tableItem.user.id : '' }}</p>
                <p>{{ tableItem.user ? tableItem.user.realname : '' }}</p>
              </div>
            </li>
            <!-- 对应人员 -->
            <li>
              <div>
                <p>{{ tableItem.user && tableItem.user.y_admin ? tableItem.user.y_admin.realname : '' }}</p>
                <p>{{ tableItem.user && tableItem.user.g_admin ? tableItem.user.g_admin.realname : '' }}</p>
                <p>{{ tableItem.user && tableItem.user.p_admin ? tableItem.user.p_admin.realname : '' }}</p>
              </div>
            </li>
            <!-- 页面链接 -->
            <li class="flex2">
              <a class="blurFont" :href="'https://www.rakumart.com' + tableItem.page_url" target="_blank">
                https://www.rakumart.com{{ tableItem.page_url }}
              </a>
            </li>
            <!-- 提出时间 -->
            <li>
              {{ tableItem.created_at }}
            </li>
            <!-- 问题描述 -->
            <li class="flex2">
              <div class="template" :title="tableItem.desc">
                {{ tableItem.desc }}
              </div>
            </li>
            <!-- 图片 -->
            <li class="imageLI">
              <div v-for="(imageItem, imageIndex) in tableItem.images" :key="imageIndex">
                <el-popover placement='right' trigger='hover'>
                  <img :src='imageItem' alt='' style="width:300px; height:300px" />
                  <img :src='imageItem' class="backImg" alt='' slot='reference' />
                </el-popover>
              </div>
            </li>
            <!-- 业务备注 -->
            <li class="flex15">
              <el-input :disabled="!!tableItem.confirm_at" @blur="feedbackupdateConfirmRemark(tableItem)"
                type="textarea" v-model="tableItem.confirm_remark" v-if="isAuth(430)"></el-input>
              <span v-else>{{ tableItem.confirm_remark }}</span>
            </li>
            <!-- 运营备注 -->
            <li class="flex15">
              <el-input @blur="updateOperatorRemark(tableItem)" type="textarea" v-model="tableItem.operator_remark"
                v-if="username == 'Y10001' || username == 'Y10002' || username == 'Y001' || username == 'Y10003' || username == 'JP010' || username == 'JP011'"></el-input>
              <span v-else>{{ tableItem.operator_remark }}</span>
            </li>
            <!-- 操作 -->
            <li class="flex05">
              <!-- 确认 -->
              <el-button v-if="!tableItem.confirm_at && isAuth(431)" size="mini" type='success' class="secondary"
                @click="feedbackconfirm(tableItem)">
                {{ $t('message.notarize') }}
              </el-button>
            </li>
            <!-- 确认状态（时间） -->
            <li>
              <!-- 文本: 待确认 -->
              {{ tableItem.confirm_at ? tableItem.confirm_at : $t('message.toBeConfirmed') }}
            </li>
          </ul>
          <div v-if="tableData == false" class="No_data">暂无数据</div>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      statusRange: "[]", //statusRange规则由split改成stringify,所以设置 "[]"为初始值
      total: 0,
      num: 0,
      datas: {
        status: '1'
      },
      tableData: [],
      username: JSON.parse(localStorage.getItem('japanUserRoleInfo')).username,
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  component: {},
  created() {
    this.feedbackList();
  },
  methods: {
    // 确认客户反馈
    feedbackconfirm(item) {
      this.$confirm("当前反馈已确认", this.$t("message.prompt"), {
        confirmButtonText: this.$t("message.cancel"),
        cancelButtonText: this.$t("message.confirm"),
        cancelButtonClass: 'primary',
        confirmButtonClass: 'dark',
        type: "warning",
        center: true,
      })
        .then(() => {

        })
        .catch(() => {

          this.$api.siteConfiguration
            .feedbackconfirm({
              id: item.id
            }).then(res => {
              ////console.log('事件名',res)
              if (res.code != 0) return this.$message.error(res.data.msg)
              //接下来的操作
              this.feedbackList()
            })
        });

    },
    // 保存备注
    feedbackupdateConfirmRemark(item) {
      this.$api.siteConfiguration
        .feedbackupdateConfirmRemark({
          id: item.id,
          confirm_remark: item.confirm_remark
        }).then(res => {
          ////console.log('事件名',res)
          if (res.code != 0) return this.$message.error(res.data.msg)
          //接下来的操作
          // this.feedbackList()
        })
    },
    //运维备注
    updateOperatorRemark(item) {
      let datas = {
        id: item.id,
        operator_remark: item.operator_remark
      }
      this.$api.siteConfiguration
        .updateOperatorRemark(datas).then(res => {
          ////console.log('事件名',res)

          this.$message.success(res.msg);
          //接下来的操作
          // this.feedbackList()
        })
    },
    // 重置
    reset() {
      this.datas = {
        user_id: this.$route.query.userID,
        statusRange: [],
      };
      this.feedbackList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.feedbackList();
    },
    // 获取配送单列表
    feedbackList() {
      this.$api.siteConfiguration.feedbackList(this.datas).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.feedbackList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.feedbackList();
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 24px 0;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
  word-break: break-all;

}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 12px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .imageLI {
    flex-wrap: wrap;
    flex: 0 0 100px;

    img {
      width: 36px;
      height: 36px;
      margin: 0 6px 6px 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;

    .template {
      width: 100%;
      height: 100%;

    }
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;

  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;


    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.listShow {
  text-align: center;
}
</style>